import { render } from "./inputCheckBox.vue?vue&type=template&id=4f1f84d9&scoped=true&ts=true&lang=html"
import script from "./inputCheckBox.vue?vue&type=script&lang=ts"
export * from "./inputCheckBox.vue?vue&type=script&lang=ts"

import "./inputCheckBox.vue?vue&type=style&index=0&id=4f1f84d9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1f84d9"]])

export default __exports__